import { render, staticRenderFns } from "./EventSellers.vue?vue&type=template&id=6ae6bef6&scoped=true&"
import script from "./EventSellers.vue?vue&type=script&lang=js&"
export * from "./EventSellers.vue?vue&type=script&lang=js&"
import style0 from "./EventSellers.vue?vue&type=style&index=0&id=6ae6bef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6bef6",
  null
  
)

export default component.exports